import React from 'react';
import { useStyles } from './styles';
import classnames from 'classnames';


interface Props {
    handleButtonClick?: Function;
    titleText?: any;
    bodyText: any;
    buttonText?: any;
}

const Information: React.FC<Props> = ({ handleButtonClick, bodyText, buttonText, titleText }) => {
    const classes = useStyles();

    return (
        <div className={classes.outerContainer}>
            <div className={classes.contentContainer}>
                {titleText && (
                    <div className={classnames(classes.headerText, classes.informationHeaderText)}>
                        <h3>{titleText}</h3>
                    </div>
                )}
                <div className={classnames(classes.informationBodyText)}>
                    {bodyText}
                </div>
                {buttonText && (
                    <div>
                        <div>
                            <button className={classes.button} onClick={() => handleButtonClick?.()}>{buttonText}</button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Information;